import React from "react";
import { NavLink } from "react-router-dom";
import {
  LuLayoutDashboard,
  LuBookOpen,
  LuCpu,
  LuActivity,
  LuFileText,
  LuLogOut,
  LuShield,
  LuDatabase
} from "react-icons/lu";

import logo from "../assets/image/logo.png";
import logolight from "../assets/image/logo-light.png";
import { useTheme } from "../ThemeContext";

import Cookies from "js-cookie";

const Nav = ({ isOpen = true }) => {
  const { theme, toggleTheme } = useTheme();
  const userRole = Cookies.get("userRole");
  const userName = localStorage.getItem("userName") || "User";
  const userEmail = localStorage.getItem("userEmail") || "user@example.com";
  const permissionsStr = Cookies.get("userPermissions");
  let permissions = [];
  try {
    permissions = permissionsStr ? JSON.parse(permissionsStr) : [];
  } catch (e) { permissions = []; }

  const hasAccess = (page) => {
    if (userRole === 'ADMIN') return true;
    return permissions.includes(page) || permissions.includes('*');
  };



  // If closed on desktop, don't render the sidebar column
  // (We'll handle the "button to open" in PageWrapper)
  if (!isOpen) return null;

  return (
    <>
      <aside className="col-lg-3 pe-lg-4 pe-xl-5 mt-n3">
        <div className="position-lg-sticky top-0">
          <div className="d-none d-lg-block">
            <div className="py-3 mb-2">
              <img src={logo} alt="Algo Logo" className="d-block d-dark-mode-none img-fluid" style={{ maxWidth: '80px' }} />
              <img class="d-none d-dark-mode-block img-fluid" src={logolight} style={{ maxWidth: '80px' }} alt="logo"></img>
            </div>
          </div>

          <div className="offcanvas-lg offcanvas-start" id="sidebarAccount">
            <button
              className="btn-close position-absolute top-0 end-0 mt-3 me-3 d-lg-none"
              type="button"
              data-bs-dismiss="offcanvas"
              data-bs-target="#sidebarAccount"
              aria-label="Close"
            ></button>

            <div className="offcanvas-body">
              <div className="d-lg-none pb-2">
                <img src={logo} alt="Algo Logo" className="d-block d-dark-mode-none img-fluid" style={{ maxWidth: '70px' }} />
                <img class="d-none d-dark-mode-block img-fluid" src={logolight} style={{ maxWidth: '70px' }} alt="logo"></img>
              </div>

              <div className="pb-2 pb-lg-0 mb-4 mb-lg-5">
                <h3 className="h5 mb-1">{userName}</h3>
                <p className="fs-sm text-body-secondary mb-0">
                  {userEmail}
                </p>
                <div className="my-3">
                  <div className="form-check form-switch d-flex align-items-center">
                    <input
                      className="form-check-input me-2"
                      type="checkbox"
                      id="themeSwitch"
                      checked={theme === 'dark'}
                      onChange={toggleTheme}
                      style={{ cursor: 'pointer' }}
                    />
                    <label className="form-check-label fw-semibold" htmlFor="themeSwitch" style={{ cursor: 'pointer' }}>
                      {theme === 'dark' ? 'Dark Mode' : 'Light Mode'}
                    </label>
                  </div>


                </div>
              </div>

              <nav className="nav flex-column pb-2 pb-lg-4 mb-3">
                <NavLink
                  to="/"
                  className={({ isActive }) =>
                    `nav-link fw-semibold py-2 ps-3${isActive ? " active" : ""}`
                  }
                >
                  <LuLayoutDashboard className="fs-5 opacity-70 me-2" />
                  Dashboard
                </NavLink>

                {hasAccess('Trade Book') && (
                  <NavLink
                    to="/tradebook"
                    className={({ isActive }) =>
                      `nav-link fw-semibold py-2 ps-3${isActive ? " active" : ""}`
                    }
                  >
                    <LuBookOpen className="fs-5 opacity-70 me-2" />
                    Trade Book
                  </NavLink>
                )}

                {hasAccess('Algo') && (
                  <NavLink
                    to="/algo"
                    className={({ isActive }) =>
                      `nav-link fw-semibold py-2 ps-3${isActive ? " active" : ""}`
                    }
                  >
                    <LuCpu className="fs-5 opacity-70 me-2" />
                    Algo
                  </NavLink>
                )}

                {hasAccess('Logs') && (
                  <>
                    <NavLink
                      to="/logs"
                      className={({ isActive }) =>
                        `nav-link fw-semibold py-2 ps-3${isActive ? " active" : ""}`
                      }
                    >
                      <LuFileText className="fs-5 opacity-70 me-2" />
                      Logs
                    </NavLink>
                    <NavLink
                      to="/api-logs"
                      className={({ isActive }) =>
                        `nav-link fw-semibold py-2 ps-3${isActive ? " active" : ""}`
                      }
                    >
                      <LuActivity className="fs-5 opacity-70 me-2" />
                      API Errors
                    </NavLink>
                  </>
                )}

                {userRole === 'ADMIN' && (
                  <>
                    <NavLink
                      to="/admin/users"
                      className={({ isActive }) =>
                        `nav-link fw-semibold py-2 ps-3${isActive ? " active" : ""}`
                      }
                    >
                      <LuShield className="fs-5 opacity-70 me-2" />
                      Users
                    </NavLink>
                    <NavLink
                      to="/admin/settings"
                      className={({ isActive }) =>
                        `nav-link fw-semibold py-2 ps-3${isActive ? " active" : ""}`
                      }
                    >
                      <LuFileText className="fs-5 opacity-70 me-2" />
                      Settings
                    </NavLink>
                    <NavLink
                      to="/admin/data"
                      className={({ isActive }) =>
                        `nav-link fw-semibold py-2 ps-3${isActive ? " active" : ""}`
                      }
                    >
                      <LuDatabase className="fs-5 opacity-70 me-2" />
                      Database
                    </NavLink>
                  </>
                )}
              </nav>

              <nav className="nav flex-column pb-2 pb-lg-4 mb-3">
                <NavLink
                  to="/logout"
                  className="nav-link fw-semibold py-2 ps-3 logout-link rounded-2"
                >
                  <LuLogOut className="fs-5 opacity-70 me-2" />
                  Log Out
                </NavLink>
              </nav>

            </div>
          </div>
        </div>
      </aside>


    </>
  );
};

export default Nav;
